import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => {
  return {
    cardsWrapper: {
      display: 'flex',
      gap: '24px',
      flexDirection: 'row',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'center',
      },
      [theme.breakpoints.up('md')]: {
        [theme.breakpoints.down('lg')]: {
          display: 'flex',
          flexWrap: 'wrap',
        },
      },
    },
    cardStyle: {
      padding: theme.spacing(3),
      width: '426px',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    title: {
      color: theme.palette.text.tertiary,
      fontSize: 16,
      fontWeight: 500,
      lineHeight: '24px',
    },
    subTitle: {
      fontSize: 36,
      fontWeight: 600,
      color: theme.palette.text.primary,
      lineHeight: '44px',
    },
    iconContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: theme.palette.background.primary,
      border: `1px solid ${theme.palette.border.secondary}`,
      borderRadius: '10px',
      width: 48,
      height: 48,
      boxShadow: '0 1px 2px 0 rgba(16, 24, 40, 0.05)',
    },
    infoContainer: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: '24px',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    filterWrapper: {
      display: 'flex',
      flexDirection: 'column',
      gap: '24px',
    },
    filtersButtons: {
      alignSelf: 'flex-end',
    },
    filtersSection: {
      display: 'flex',
      [theme.breakpoints.down('780')]: {
        flexDirection: 'column',
        // maxWidth: '500px',
        width: '100%',
        gap: '17px',
      },
    },
    filtersContainer: {
      display: 'flex',
      gap: '12px',
      width: '100%',
      '& .input-wrapper': {
        maxWidth: '291px',
      },
      [theme.breakpoints.down('1500')]: {
        minWidth: 'initial',
        flexWrap: 'wrap',
        rowGap: '12px',
      },
      [theme.breakpoints.down('1345')]: {
        '& .input-wrapper': {
          maxWidth: '190px',
        },
      },
      [theme.breakpoints.down('780')]: {
        '& .input-wrapper': {
          maxWidth: '190px',
        },
      },
      [theme.breakpoints.down('420')]: {
        '& .input-wrapper': {
          maxWidth: '165px',
        },
      },
    },
    icon: {
      marginRight: '8px',
    },
    inputwrapper: {
      width: '100% !important',
      maxWidth: '392px',
    },
    autoCompleteInput: {
      minWidth: '190px',
      [theme.breakpoints.down('420')]: {
        maxWidth: '165px',
        width: '100% !important',
        minWidth: 'initial',
      },
    },
    dateFilterContainer: {
      display: 'flex',
      alignSelf: 'flex-start',
      width: '100%',
      gap: '12px',
      [theme.breakpoints.down('780')]: {
        '& > *': {
          width: '190px',
        },
      },
      [theme.breakpoints.down('420')]: {
        '& > *': {
          width: '165px',
        },
      },
    },
    dateFilter: {
      marginLeft: 'auto',
      padding: '10px 16px',
      fontSize: '16px',
      fontWeight: 600,
      whiteSpace: 'nowrap',
      background: theme.palette.background.paper,
      color: theme.palette.text.secondary,
      borderRadius: '8px',
      border: `1px solid ${theme.palette.foreground.senary}`,
      alignSelf: 'flex-start',
      textAlign: 'center',
      [theme.breakpoints.down('780')]: {
        marginLeft: '0',
      },
    },
    agentNameWrapper: {
      display: 'flex',
      gap: '12px',
      alignItems: 'center',
    },
    avatar: {
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      backgroundColor: theme.palette.background.secondary_hover,
      color: theme.palette.text.text_quarterary,
      fontSize: '16px',
      fontWeight: 600,
      border: '0.75px solid rgba(0, 0, 0, 0.08)',
    },
    tableHeader: {
      display: 'flex',
      alignItems: 'center',
      height: '44px',
      color: '#475467',
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '20px',
    },
  };
});
